// src/router/part.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const partRoutes: RouteRecordRaw[] = [
  {
    path: 'part',
    name: 'part',
    component: () => import('@/views/page/part/PartData.vue'),
    meta: { title: 'Part' },
  },
  {
    path: 'part/trash',
    name: 'part-trash',
    component: () => import('@/views/page/part/PartData.vue'),
    meta: { title: 'Part Trash' },
  },
  {
    path: 'part/create/',
    name: 'part-create',
    component: () => import('@/views/page/part/PartInput.vue'),
    meta: { title: 'Create Part' },
  },
  {
    path: 'part/:id/edit',
    name: 'part-edit',
    component: () => import('@/views/page/part/PartInput.vue'),
    meta: { title: 'Edit Part' },
  },
]
